<template>
<div>
    <!--DESKTOP -->
    <div class="bande is-hidden-touch">
        <!--Titre-->
         <p class="TitreService is-size-2">   <img  src="../../public/assets/img/Service.png" class="ImgService">LA NOTION DE SERVICE </p>
          <!--colonnes-->
          <div v-if="isShow" class="columns">
            <!--colonne 1 -->
            <div class="column is-half" >
                <!--colonne 1 : image -->
                <img  :src="image" style="width:65%; margin-top:10%;margin-right:auto;margin-left:25%;">
            </div>
             <!--colonne 2  -->
            <div  class="column is-half" style="width:33%;margin-left:5%;">
                <!--colonne 2 : description titre -->
                <p class="is-size-3"  style=" margin-left:25%;margin-right:auto; margin-top:20%;text-align:justify; font-family: 'Montserrat', sans-serif; font-weight:bolder;" >LES SERVICES </p>
                 <!--colonne 2 : description  -->
                    <p class="is-size-4"  style="margin-top:10%;text-align:justify;font-family: 'Lato', sans-serif;"> 
                        Le service est une notion qui nous tient particulièrement à coeur. En effet, nous nous engageons à vous accompagner et à vous soutenir durant vos réalisations, du début à la fin.<br>
                        Chaque service rendu vous permettra de vous rapprocher de votre but.<br><br>
                        À l'image de cette peinture qui prend sens une fois complète, vos projets prendront vie graces à nos services. 
                    </p>   
            </div>
        </div>  
        <!-- bouton précédent et suivant -->
        <!-- bouton precedent qui montre le texte -->
        <button class="btn btn-left" v-on:click="Show() "><img  src="../../public/assets/img/chevronleft.png" class="icon"  ></button>
        <!-- bouton suiant qui  ne montre pas le texte et change le lien de l'image -->
        <button class="btn btn-right" v-on:click="NotShow()" ><img  src="../../public/assets/img/chevronright.png" class="icon" ></button>   
        
         <!--colonne 1 -->
         <div v-if="!isShow" class="column is-full">
             <!--colonne 1 : image -->
            <img  style="width:65%; margin-left:auto;margin-right:auto;margin-top:5%;" :src="image" >          
        </div>
 
   

           
    </div>

    <!-- MOBILE TABLET-->
    <div class="mobile is-hidden-desktop"  style="margin-top:35%;">
        <!--Titre-->
        <p class="is-size-5" style="text-align:center; " > LA NOTION DE SERVICE </p>
        
        <div  v-if="!isShow">   
            <img :src="image" style="width:100%;margin-top:10%; margin-left:3%;"/>
        </div>
       
        <div  v-if="isShow">   
            <img :src="image" style="width:90%;margin-top:10%;"/>
        </div>
        <!-- bouton précédent et suivant -->
        <!-- bouton precedent qui montre le texte -->
        <button class="btnMobile" v-on:click="Show() " ><img  src="../../public/assets/img/chevronleft.png" class="icon"></button>
         <!-- bouton suiant qui  ne montre pas le texte et change le lien de l'image -->
        <button class="btnMobile" v-on:click="NotShowMobile() "><img  src="../../public/assets/img/chevronright.png" class="icon"></button>
       
      
             <!-- description -->
            <p class="is-size-6"  style=" margin-top:3%; margin-bottom:10%; margin-right:10%; margin-left:10%; font-family: 'Lato', sans-serif; text-align:justify;"> 
                Le service est une notion qui nous tient particulièrement à coeur. En effet, nous nous engageons à vous accompagner et à vous soutenir durant vos réalisations, du début à la fin.<br>
                Chaque service rendu vous permettra de vous rapprocher de votre but.<br><br>
                À l'image de cette peinture qui prend sens une fois complète, vos projets prendront vie graces à nos services. 
            </p> 
        
           
           
    
     </div>
 
</div>
</template>


<script>


export default {
  name: "Slides",
   components: {
   
  },

 
  data:function(){
      return {
          index:0,
          counter: 0,
          image : "./assets/img/Slide.png",
          isShow :true,
          transition:"transform 0.2s ease"
      }
  },
  methods:{
       NotShow: function() {
            this.isShow = false;
            this.image = "./assets/img/graphe.png";
        },
        NotShowMobile: function() {
            this.isShow = false;
            this.image = "./assets/img/graphemobile.png";
        },
        Show: function() {
            this.isShow = true;
            this.image = "./assets/img/Slide.png";
        },

  }
}
</script>
<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');





.ImgService{
 margin-right:4%;
 width:3.5%;
 vertical-align:middle;
}

.TitreService{
    background-color: #482A5C;
    margin-top:-2%;
    padding-top:1.3%;
    color:white;
    height:150px;
    width:100%;
    font-family: 'Montserrat', sans-serif;

}
.bande{
    width:100%;
    height: 100vh;
    padding-top:1%;
   
    position:relative;
}


.btn{
    outline:none;
    border:none;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display:block;
    position: absolute;
    z-index:1000;
    cursor: pointer;
    display:flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;

    
}
.btnMobile{
    outline:none;
    border:none; 
    background-color: transparent;
    width: 40px;
    height: auto;
    margin-top:12%; margin-bottom:12%;
}
.icon{
    width:300%;
    height: auto;
}
.btn-left{
    top:50%;
    left:25px;
    transform: translateY(-50%);
}

.btn-right{
    top:50%;
    right:25px;
    transform: translateY(-50%);
}
</style>